import http from '@/assets/common/http';
// ------------------------------------采购价管理
export function shopPriceFun(data) {
  const params = {
    SERVICE_ID: '10023',
    OTYPE: 1,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// -----------------------------------导出采购价
export function exportShopPriceFun(data) {
  const params = {
    SERVICE_ID: '10023',
    OTYPE: 2,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// -----------------------------------导入采购价
export function importShopPriceFun(data) {
  const params = {
    SERVICE_ID: '10023',
    OTYPE: 3,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------售价管理
// -------------------------------------------------搜索产品名称
export function queryProductFun(data) {
  const params = {
    SERVICE_ID: '10008',
    // OTYPE: 16,
    OTYPE: 10,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------------获取供应商
export function haveTCFun() {
  const params = {
    // SERVICE_ID: '10009',
    SERVICE_ID: '10005',
    OTYPE: 8,
    // OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// --------------------------------------------------获取项目点
export function haveXMDFun(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------提交售价
export function submitPriceFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/shopPrice.js